import React from "react";
import {headShake} from 'react-animations';
import Radium, {StyleRoot} from 'radium';
import {ListGroup, OverlayTrigger, Popover} from "react-bootstrap";
import {connect} from "react-redux";
import i18n from "../../i18nextInitiator";

const t = i18n.getFixedT('fa','guide');
const mapStateToProps = state => ({ ...state });
const mapDispatchToProps = dispatch => ({});

const styles = {
  bounce: {
      animation: 'x 2s',
      animationDelay: '2s',
      animationName: Radium.keyframes(headShake, 'headShake')
  }
}

const FloatingBtn = props => {
  var content;
  switch(props.place){
    case 'cars':
        content = {
          title: t('cars.title'),
          items: [
              t('cars.rows.0'), t('cars.rows.1'), t('cars.rows.2'), t('cars.rows.3'), t('cars.rows.4'),
          ]
          }
          break;
    case 'expensive':
        content = {
          title: "سوالات شما در مورد وسایل سنگین",
          items: [
          "تفاوت وسایل سنگین در این است که هزینه حمل آنها به طور مجزا به مبلغ کارگری اضافه می شود و برای هر طبقه در مبدا یا مقصد هم هزینه اضافه تری محاسبه می شود.",
            "اگر شک دارید که یکی از وسایل شما سنگین محسوب می شود یا نه با پشتیبانی نوبار تماس بگیرید.",
            "با انتخاب هر وسیله سنگین، قیمت آن به جمع مبلغ سفارش اضافه می شود.",
            "با اضافه کردن هر طبقه در مبدا یا مقصد در هنگام سفارش، قیمت آن به جمع مبلغ سفارش اضافه می شود.",
            // "اضافه قیمت برای محدوده طبقات 0 تا 3 ، 3 تا 7، و 7 به بالا متفاوت است."
            ]
          }
          break;
      case 'workers':
          content = {
            title: "سوالات شما در مورد انتخاب کارگر",
            items: [
              "اگر هیچ نیازی به کمک راننده ندارید ماشین بدون کارگر سفارش دهید.",
              "اگر یک کارگر انتخاب کنید، راننده به عنوان کارگری که بار را در ماشین می چیند و پیاده می کند به شما خدمت ارائه می کند.",
                `اگر نیاز به کارگر باربر غیر از راننده دارید، به تعداد مورد نیاز کارگر به راننده اضافه کنید.
                 مثلاً برای حمل کمد از منزل به نیسان، باید 2 کارگر انتخاب کنید که یکی کارگر باربر خواهد بود
                  و دیگری راننده است که به کارگر در حمل بار و چینش آن در ماشین کمک می کند.
                (برای نمونه اگر 4 کارگر انتخاب کنید، 3 کارگر برای حمل بار و راننده در ماشین برای چینش خدمات می دهند.)`
            ]
          }
          break;
      case 'timing':
          content = {
            title: 'سوالات شما در مورد انتخاب زمان باربری',
            items: [
              "اگر برای همین الان، چند ساعت دیگر یا چند روز دیگر درخواست باربری دارید می توانید سفارشتان را با خیال راحت ثبت کنید.",
              "سیستم نوبار درخواست شما را برای رانندگان مربوطه می فرستد و بعد از تایید یک راننده، با پیامک به شما اطلاع می دهیم.",
              "اگر برای روزهای آخر هفته درخواست باربری دارید بهتر است زودتر درخواستتان را ثبت کنید تا ظرفیت پر نشود.",

            ]
          }
          break;
      case 'location':
          content = {
            title: 'سوالات شما در مورد انتخاب آدرس',
            items: [
              'پس از انتخاب مبدا و مقصد، طبقه و وجود آسانسور باربری را نیز مشخص کنید.',
              'فعلا نوبار در محدوده داخل تهران به شما خدمت رسانی می کند. بزودی در حومه و شهرستان هم در کنار شما خواهیم بود.',
              'قیمت در محدوده ترافیک طبق تعرفه افزایش می یابد.',
              'با اضافه کردن طبقه در مبدا و مقصد هزینه کارگری با ضریبی اضافه می شود و قیمت نمایش داده به شما اضافه می شود.',
              'اگر آسانسور باربری دارید و می خواهید وسایل سنگینتان را با استفاده از آن جابجا کنید، هزینه اضافه وسایل سنگین برای طبقات حذف می شود.'
            ]
          }
          break;
      case 'submitOrder':
          content = {
            title: 'سوالات شما در مورد ثبت سفارش',
            items: [
              "بعد از ثبت سفارش لینک صفحه پیگیری سفارش برای شما پیامک می شود. همیشه از طریق این لینک می توانید جزئیات و وضعیت سفارشتان را ببینید.",
              "در صفحه پیگیری سفارش امکان مشاهده فاکتور و لغو سفارش را دارید.",
              "بعد از پایان باربری می توانید در صفحه پیگیری سفارش امتیاز و نظرتان راجع به باربری را به ما اعلام کنید.",

            ]
          }
          break;
      case 'moreService':
          content = {
            title: 'سوالات شما کارگر بسته بندی و چیدمان',
            items: [
              "اگر نیاز دارید وسایلتان بسته بندی شوند، یا پس از حمل در چیدمان نیاز به کمک دارید می توانید کارگر بسته بندی یا چیدمان هم به سفارشتان اضافه کنید.",
              "کارگر فنی شما را در باز کردن وسایل منزل در مبدا و نصب مجدد آنها در مقصد یاری می کند."
            ]
          }
          break;
          
      default:
        content = {title:'', items:['']}
  }

  return(
    <StyleRoot>
      <OverlayTrigger
          rootClose={true} trigger="click" placement="auto" overlay={
          <Popover id="popover-basic" className="instruction-popover" style={{marginTop:15}}>
            <Popover.Title>{content.title}</Popover.Title>
                <Popover.Content className={'head'} >
                  <ListGroup variant="flush">
                    {
                      content.items.map(item=>{
                        return <ListGroup.Item>{item}</ListGroup.Item>
                      })
                    }

                  </ListGroup>

                </Popover.Content>

          </Popover>
      }>

          <div className="floating-btn" id={`floating-${props.place}`} style={styles.bounce}>
            <p>راهنما</p>
          </div>

      </OverlayTrigger>
      </StyleRoot>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(FloatingBtn);
